import store from '@/store/index'
import Vue from 'vue'
import { WS_REQUEST_POOLS } from '@/store/websentinel/websentinel.types'

export const state = {
  /*
   * eventPoolsSelectionSets is a "grouping" of multiple pools that are
   * selected. For example, one might wish to have a "global" set of
   * selected pools that is persistent across all screens or one
   * might want to create a set of selected pools for a particular
   * individual/group of widgets.
   */
  eventPoolsSelectionSets: {}
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected pools.
   *
   * @param state Object
   *
   * @return Object
   */
  eventPoolsSelectionSets (state) {
    return state.eventPoolsSelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more pools.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return store.dispatch(WS_REQUEST_POOLS)
  }
}

export const mutations = {
  /**
   * Add a map or array of object pools that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param pools Array|Map
   */
  addSelectedPools (state, { set, pools }) {
    if (!state.eventPoolsSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.eventPoolsSelectionSets, set, {})
    }

    pools.forEach(pool => {
      Vue.set(state.eventPoolsSelectionSets[set], pool.id, pool)
    })
  },

  /**
   * Set a single selected pool, all other selected pools
   * in the set will be cleared.
   *
   * @param state  Object
   * @param set    String
   * @param pool Object
   */
  setSelectedPool (state, { set, pool }) {
    Vue.set(state.eventPoolsSelectionSets, set, {})
    Vue.set(state.eventPoolsSelectionSets[set], pool.id, pool)
  },

  /**
   * Removes an array of pools from the set's list of selected pools.
   * The array must consist of the id's of the pools that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param pools Array
   */
  removeSelectedPools (state, { set, pools }) {
    if (state.eventPoolsSelectionSets.hasOwnProperty(set)) {
      pools.forEach(pool => {
        Vue.delete(state.eventPoolsSelectionSets[set], pool.id)
      })
    }
  },

  /**
   * Clears all selected pools.
   *
   * @param state  Object
   */
  clearAllSelectedPools (state) {
    Vue.set(state, 'eventPoolsSelectionSets', {})
  },

  /**
   * Clears all selected pools within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedPools (state, set) {
    if (state.eventPoolsSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.eventPoolsSelectionSets, set, {})
    }
  },

  /**
   * Clears all pools.
   *
   * @param state Object
   */
  purge (state) {
    state.eventPoolsSelectionSets = {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/events/pools/findWsEventPoolsWidgetModule.js